import type { AstroTransitionLinkProps } from "@site-types/components/astroTransitionLink"

export function AstroTransitionLink({ children, to, transitionName, ...props }: AstroTransitionLinkProps) {
  return (
    <a
      {...props}
      href={to}
      data-view-transition-link="true"
      data-content-transition-name={transitionName}
      data-news-transition-name={transitionName}
    >
      {children}
    </a>
  )
}

export default AstroTransitionLink
